import {
  mergeAttributes,
  Node,
  NodeViewWrapper,
  ReactNodeViewRenderer
} from '@tiptap/react';

export interface SlashTokenAttributes {
  label: string;
  value: string;
}

const SlashTokenComponent: Parameters<typeof ReactNodeViewRenderer>[0] = ({
  node
}) => {
  const { label } = node.attrs as SlashTokenAttributes;

  return (
    <NodeViewWrapper
      className="slash-token"
      contentEditable={false}
    >
      {label}
    </NodeViewWrapper>
  );
};

const SlashToken = Node.create({
  addAttributes() {
    return {
      label: {
        default: '',
        parseHTML: element => element.getAttribute('data-label'),
        renderHTML: (attrs: SlashTokenAttributes) => ({
          'data-label': attrs.label
        })
      },
      value: {
        default: '',
        parseHTML: element => element.getAttribute('data-value'),
        renderHTML: (attrs: SlashTokenAttributes) => ({
          'data-value': attrs.value
        })
      }
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(SlashTokenComponent);
  },
  atom: true,
  group: 'inline',
  inline: true,
  name: 'slashToken',
  parseHTML() {
    return [{ tag: 'span.slash-token' }];
  },
  renderHTML({ HTMLAttributes, node }) {
    return [
      'span',
      mergeAttributes({ class: 'slash-token' }, HTMLAttributes),
      node.attrs.label
    ];
  }
});

export default SlashToken;
